
























import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class Alert extends Vue {
  @Prop() public title!: string;
  @Prop() public description!: string;
  @Prop() public showArrow!: boolean;
  get isShow() {
    return this.showArrow;
  }
  public link() {
    window.location.href = 'https://nanoverify.com.my/contact-us/';

  }
}
